import { Suspense, lazy } from 'react'
import StoreApp from '@!/Store/Common/containers/StoreApp'
import { AppProvider } from '@!/providers'
const SearchFree = lazy(() => import('@!/Store/SearchFree/containers/SearchFree'))

const SearchFreeApp = (props) => {
  return (
    <AppProvider>
      <StoreApp {...props}>
        <Suspense fallback={null}>
          <SearchFree genreTabName={props.genre_tab_name} />
        </Suspense>
      </StoreApp>
    </AppProvider>
  )
}

export default SearchFreeApp
